import React, { useRef } from "react";
import * as d3 from "d3";
import { navigate } from "gatsby";

const BIG_BLOCKS = [`D3`, `E3`];

function Streets({ data, width, height }) {
  const { north, south, east, west } = data;
  return (
    <g>
      <text
        className="text-sm"
        pointerEvents="none"
        textAnchor="middle"
        x={width / 2}
        y={20}
      >
        {north}
      </text>
      <text
        className="text-sm"
        pointerEvents="none"
        textAnchor="middle"
        x={width / 2}
        y={height - 10}
      >
        {south}
      </text>
      <text
        className="text-sm"
        pointerEvents="none"
        textAnchor="middle"
        transform={`translate(0, ${height / 2}) rotate(-90)`}
        y={20}
      >
        {east}
      </text>
      <text
        className="text-sm"
        pointerEvents="none"
        textAnchor="middle"
        transform={`translate(${width - 20}, ${height / 2}) rotate(90)`}
      >
        {west}
      </text>
    </g>
  );
}

function StreetLink({ node, colScale, rowScale, current }) {
  const name = node.frontmatter.title;
  const [row, col] = name.split(``);
  const x = colScale(col);
  const y = rowScale(row);
  const box = useRef(null);
  const fill = current === name ? `#eee` : `#CACACA`;

  const handleClick = () => {
    navigate(`/${name}`);
  };

  const handleMouseOver = () => {
    box.current.style.fill = `#eee`;
  };
  const handleMouseOut = () => {
    box.current.style.fill = fill;
  };

  let width = colScale.bandwidth();
  if (BIG_BLOCKS.includes(name)) {
    width = colScale.bandwidth() * 2 + colScale.padding() * colScale.step();
  }
  const height = rowScale.bandwidth();
  return (
    <g transform={`translate(${x},${y})`}>
      <rect
        cursor="pointer"
        fill={fill}
        height={height}
        onClick={handleClick}
        onMouseOut={handleMouseOut}
        onMouseOver={handleMouseOver}
        pointerEvents="all"
        ref={box}
        width={width}
      ></rect>
      <text
        alignmentBaseline="central"
        className="text-4xl"
        dominantBaseline="central"
        pointerEvents="none"
        textAnchor="middle"
        x={width / 2}
        y={height / 2}
      >
        {name}
      </text>
      <Streets data={node.frontmatter} height={height} width={width} />
    </g>
  );
}

function MapGrid({ pages, width, current }) {
  const height = width;
  const colScale = d3
    .scaleBand()
    .padding(0.1)
    .range([0, width])
    .domain([1, 2, 3, 4]);
  const rowScale = d3
    .scaleBand()
    .padding(0.2)
    .range([0, width])
    .range([0, height])
    .domain([`A`, `B`, `C`, `D`, `E`]);
  return (
    <div className="py-3">
      <svg height={height} width={width}>
        {pages.map(({ node }) => (
          <StreetLink
            colScale={colScale}
            current={current}
            key={node.id}
            node={node}
            rowScale={rowScale}
          />
        ))}
      </svg>
    </div>
  );
}

MapGrid.defaultProps = {
  width: 800,
  height: 800
};

export default MapGrid;
